import React, { CSSProperties } from 'react';
import { Navigation } from '../../global-functions';
import { withRouter, RouteComponentProps } from 'react-router';
import { RootState } from '../../store';
import { connect } from 'react-redux';

interface SmartLinkProps extends RouteComponentProps {
    children: JSX.Element;
    to: string;
    title?: string;
    className?: string;
    style?: CSSProperties;
    spaPath: string;
    target?: string;
}

/** Handles navigation for internal and external urls */
const SmartLink = ({
    history,
    children,
    to,
    title,
    className,
    style,
    spaPath,
    target,
}: SmartLinkProps) => {
    let buttonCss = to
        ? 'btn-block btn-link '
        : 'btn-block btn-link not-a-link ';
    if (className) {
        buttonCss += className;
    }

    const handleClick = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        e.stopPropagation();
        Navigation.smartNavigate(to, spaPath, history, target);
    };

    return (
        <>
            <button
                className={buttonCss}
                type="button"
                title={title}
                style={style}
                onClick={to ? handleClick : undefined}
            >
                {children}
            </button>
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    spaPath: state.spaPath,
});

const mapDispatchToProps = {};

const smartLinkContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SmartLink);

export default withRouter(smartLinkContainer);
